import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { goToPage, setPercent, openWhatsAppChat, createWorkOrder, setServiceMessageID, report } from '../MovingBlockSlice';
import ServiceMessages from '../Partials/ServiceMessages/ServiceMessages';
import ProgressLine from '../Partials/ProgressLine/ProgressLine';
import MovingFooter from '../Partials/MovingFooter/MovingFooter';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import { gtag4 } from '../../../../utilities/analytics/tracking';

const ServiceMessagesPage = (props) => {
  let iconType = "";
  let title = "";
  let subTitle = "";
  let btnText = "סיום";
  let isDisplayWhatsApp = false;


  useEffect(() => {
    props.setPercent(45);
  }, []);

  switch (props.messageId) {
    case "TECHNICIAN_UPDATE_NOT_NEEDED":
      iconType = "like";
      title = "איזה כיף! סיימנו";
      subTitle = "ברגעים אלו נשלחה אליך הודעת SMS על החיבור לאחר המעבר";
      btnText = "סיום";
      break;
    case "TECHNICIAN_UPDATE_NOT_NEEDED_WITH_MAIL":
      iconType = "error";
      title = "השירותים שברשותך לא דורשים טכנאי";
      subTitle = "אם בכל זאת יש לך שירות כזה, כדאי לבדוק אם הוא רשום על לקוח אחר";
      btnText = "סיום";
      googleAnalyticsDisplayPage('Moving_Step2_EndOfProcessWithoutUpdatePage', 'EndOfProcessWithoutUpdatePage', '2', '2 - MovingWithoutProducts');
      break;
    case "TECHNICIAN_UPDATE_NOT_NEEDED_TV_APP":
      iconType = "like";
      title = "איזה כיף! סיימנו";
      subTitle = "ברגעים אלו נשלחה אליך הודעת SMS על החיבור לאחר המעבר";
      btnText = "סיום";
      break;
    case "OPEN_ORDER":
      isDisplayWhatsApp = props.activityTime;
      iconType = "notification";
      title =  "מסתבר שכבר יש לך הזמנה פתוחה";
      subTitle = props.activityTime ? "נמשיך מפה עם מומחה שלנו ב-Whatsapp" :"נחזור אליך ממש בקרוב כדי להשלים את המעבר";
      btnText = props.activityTime ? "בואו נמשיך בוואטסאפ" : "חזרה לעמוד הראשי";
      if (props.isEndOfProcess) {
        googleAnalyticsEndOfProcess();
      }
      else {
        googleAnalyticsDisplayPage(isDisplayWhatsApp ? 'Moving_Step3_OpenOrderContactPage' : 'Moving_Step3_OpenOrderPage', isDisplayWhatsApp ? 'OpenOrderContactPage' : 'OpenOrderPage', '3', '1 - MovingWithProducts');
      }
      break;
    case "LAST_DETAILS":
      isDisplayWhatsApp = props.activityTime;
      iconType = props.activityTime ? "whatsapp" : "call";
      title = props.activityTime ? "מעולה, נשאר לסגור כמה פרטים להשלמת ההזמנה" :"מעולה, כמעט סיימנו";
      subTitle = props.activityTime ? "" : "אנחנו נחזור אליך ממש בקרוב כדי להמשיך מאיפה שהפסקת ולהשלים את ההזמנה";
      btnText = props.activityTime ? "בואו נמשיך בוואטסאפ" : "חזרה לעמוד הראשי";
      if (props.isEndOfProcess) {
        googleAnalyticsEndOfProcess();
      }
      else {
        googleAnalyticsDisplayPage(isDisplayWhatsApp ? 'Moving_Step3_WhatsappRepPage' : 'Moving_Step3_RepHoraatAvodaPage', isDisplayWhatsApp ? 'WhatsappRepPage' : 'RepHoraatAvodaPage', '3', '1 - MovingWithProducts');
      }
      break;
    case "OPTICAL_FIBER_FOUNDED":
      isDisplayWhatsApp = props.activityTime;
      iconType = "notification";
      title = "חדשות מעולות!";
      subTitle = props.activityTime ? "נמשיך מכאן לשירות אישי ב-Whatsapp" :
      (
        <div  style={{ lineHeight: '27px' }}>
          אפשר להתחבר ל-Fiber בכתובת החדשה<br />
          וליהנות מגלישה מהירה ומשודרגת.<br /><br />
          נחזור אליך ממש בקרוב<br />
          כדי להשלים את המעבר
        </div>
      );
      btnText = props.activityTime ? "בואו נמשיך בוואטסאפ": "חזרה לעמוד הראשי";
      if (props.isEndOfProcess) {
        googleAnalyticsEndOfProcess();
      }
      else {
        googleAnalyticsDisplayPage(isDisplayWhatsApp ? 'Moving_Step3_WatsappRepSivimInAddressPage' : 'Moving_Step3_RepSivimInAddressPage', isDisplayWhatsApp ? 'WatsappRepSivimInAddressPage' : 'RepSivimInAddressPage', '3', '1 - MovingWithProducts');
      }
      break;
    case "OTHER_PACKAGES":
      iconType = "like";
      title = "מעולה! נשמח להציע לך מגוון חבילות סיבים";
      subTitle = "נציגנו יחזור אליך בהקדם האפשרי כדי לסיים את התהליך";
      btnText = "חזרה לעמוד הראשי";
      break;
    case "TECHNICIAN_MOMENT":
      iconType = "call";
      title = "מעולה! עוד רגע נתאם טכנאי";
      subTitle = "שמרנו את כל הפרטים ונציגנו יחזור אליך לתיאום טכנאי ליום המעבר לבנתיים יכולים להתחיל לארוז..";
      btnText = "חזרה לעמוד הראשי";
      break;
    case "CALLBACK_SUCCESS":
      iconType = "like";
      title = "קיבלנו את הפנייה \n נציג יחזור אליך בהתאם לשעות פעילות המוקד";
      subTitle = "";
      btnText = "חזרה לעמוד הראשי";
      googleAnalyticsDisplayPage('Moving_Step4_RepSuccessMessage_S3', 'RepSuccessMessage_S3', '4', '1 - MovingWithProducts');
      break;
    case "WHATSAPP_SUCCESS":
      iconType = "like";
      title = `מעולה,\nעוד רגע נשלח הודעה ל-${props.contactNumber} וניקח את זה משם`;
      subTitle = "";
      btnText = "חזרה לעמוד הראשי";
      googleAnalyticsDisplayPage('Moving_Step4_RepWhatsappSuccessMessage_S3', 'RepWhatsappSuccessMessage_S3', '4', '1 - MovingWithProducts');
      break;
  }



  function googleAnalyticsEndOfProcess() {
    if (props.isEndOfProcess) {
      if (props.movingWithTechnician) {
        gtag4({
          event: 'Moving_Step5_ErrorEndOfProcessPage_S4',
          title: title,
          error: props.workOrderDetails?.reason,
          step: '5',
          action: 'ErrorEndOfProcessPage_S4',
          funnel_name: '1 - MovingWithProducts'
        });
      }
      else {
        if (props.products.length == 0) {
          gtag4({
            event: 'Moving_Step4_ErrorEndOfProcess_S3',
            title: title,
            error: props.workOrderDetails?.reason,
            step: '4',
            action: 'ErrorEndOfProcess_S3',
            funnel_name: '1 - MovingWithProducts'
          });
        }
        else {
          gtag4({
            event: 'Moving_Step3_EndOfProcessErrorPage',
            title: title,
            error: props.workOrderDetails?.reason,
            step: '3',
            action: 'EndOfProcessErrorPage',
            funnel_name: '2 - MovingWithoutProducts'
          });
        }

      }
    }
  }


  function googleAnalyticsDisplayPage(event, action, step, funnel_name) {
    gtag4({
      event: event,
      title: title,
      step: step,
      action: action,
      funnel_name: funnel_name
    });
  }

  function googleAnalyticsOnClickWhatsappBtn() {

    let action = '';
    let event = '';

    switch (props.messageId) {
      case 'OPEN_ORDER':
        event = 'Moving_Step3_OpenOrderWhatsappButton';
        action = 'OpenOrderWhatsappButton';
        break;
      case 'OPTICAL_FIBER_FOUNDED':
        event = 'Moving_Step3_WatsappRepSivimInAddressButton';
        action = 'WatsappRepSivimInAddressButton';
        break;
      case 'LAST_DETAILS':
        event = 'Moving_Step3_WhatsappRepButton';
        action = 'WhatsappRepButton';
        break;
    }

    gtag4({
      event: event,
      title: title,
      button: btnText,
      step: '3',
      action: action,
      funnel_name: '1 - MovingWithProducts',
    });
  }


  function googleAnalyticsOnClickCallBackService() {

    let action = '';
    let event = '';

    switch (props.messageId) {
      case 'OPEN_ORDER':
        event = 'Moving_Step3_OpenOrderRepButton';
        action = 'OpenOrderRepButton';
        break;
      case 'OPTICAL_FIBER_FOUNDED':
        event = 'Moving_Step3_RepSivimInAddressButton';
        action = 'RepSivimInAddressButton';
        break;
      case 'LAST_DETAILS':
        event = 'Moving_Step3_RepButton';
        action = 'RepButton';
        break;
    }

    gtag4({
      event: event,
      title: title,
      button: btnText,
      step: '3',
      action: action,
      funnel_name: '1 - MovingWithProducts',
    });
  }

  async function callBackService() {
    googleAnalyticsOnClickCallBackService();
    props.report({
      actionType: 'Redirect to Service Message',
      status: 'Ongoing',
      messageText: 'Call me Button Clicked',
      products: props.products,
      param2: props.fullAddress,
      selectedProducts: props.selectedProducts,
      param4: props.selectedEntry?.infrastructure,
      param9: props.workOrderDetails?.reason,
      param10: props.workOrderDetails?.code,
    });
    if (props.workOrderDetails.isOpen) {
      props.showAppLoader();
      let openWorkOrder = await props.createWorkOrder(props.workOrderDetails);
      props.hideAppLoader();
      if (openWorkOrder.payload.isSuccess) {
        props.setServiceMessageID('CALLBACK_SUCCESS');
        props.goToPage("serviceMessagesPage");
      }
    } else {//כבר יש ללקוח הו"ע פתוחה
      props.setServiceMessageID('CALLBACK_SUCCESS');
      props.goToPage("serviceMessagesPage");
    }
  }

  function handleBtnClick() {
    if (isDisplayWhatsApp) {
      googleAnalyticsOnClickWhatsappBtn();
      props.openWhatsAppChat();
      return;
    }
    props.context.navigateTo("/");
  }

  return (
    <>
      <ProgressLine percent={props.percent} />
      <ServiceMessages title={title} subTitle={subTitle} iconType={iconType} />
      <MovingFooter
        onBtnClick={handleBtnClick}
        btnText={btnText}
        isDisplayWhatsApp={isDisplayWhatsApp}
        callBackService={callBackService}
      />
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    messageId: state.movingBlock.movingApartmentData.messageId,
    activityTime: state.movingBlock.movingApartmentData.activityTime,
    contactNumber: state.authentication.loginData.userDetails.contactNumber,
    workOrderDetails: state.movingBlock.movingApartmentData.workOrderDetails,

    products: state.movingBlock.movingApartmentData.products,
    fullAddress: state.movingBlock.movingApartmentData.address.fullAddress,
    selectedProducts: state.movingBlock.movingApartmentData.selectedProducts,
    selectedEntry: state.movingBlock.movingApartmentData.address.selectedEntry,
    isEndOfProcess: state.movingBlock.movingApartmentData.isEndOfProcess,
    movingWithTechnician: state.movingBlock.movingApartmentData.movingWithTechnician,

  };
};

const mapDispatchToProps = { goToPage, setPercent, openWhatsAppChat, createWorkOrder, setServiceMessageID, showAppLoader, hideAppLoader, report };

export default connect(mapStateToProps, mapDispatchToProps)(ServiceMessagesPage);
